<template>
  <div class="team-detail-action">
    <ym-team-status v-if="showTeamStatus"
                    :status="status"
    />
    <ym-team-count-down v-else
                        :team-size="teamSize"
                        :member-length="memberLength"
                        :current-time="currentTime"
                        :expired-time="expiredTime"
    />
    <div class="team-detail-action-buttons">
      <ym-button v-if="buttons.length > 1"
                 class="team-detail-action-button"
                 :type="secondaryBtn.type"
                 size="large"
                 :disabled="secondaryBtn.disabled"
                 @click="handleClickBtn(secondaryBtn)"
      >
        {{ secondaryBtn.hint }}
      </ym-button>
      <ym-button class="js-share-btn team-detail-action-button"
                 :type="primaryBtn.type"
                 size="large"
                 :disabled="primaryBtn.disabled"
                 @click="handleClickBtn(primaryBtn)"
      >
        {{ primaryBtn.hint }}
      </ym-button>
    </div>
    <share-mask :show.sync="showShareMask"
                :share-path="sharePath"
                message="请复制下方链接，邀请好友参加"
    />
    <confirm-pay-popup :show.sync="showPayPopup"
                       :targetId="benefitPopupTargetId"
                       :targetType="benefitPopupTargetType"
                       :title="benefitPopupTargetTitle"
                       :recommend="mixinRecommendBenefit"
                       :benefits="mixinBenefits"
                       :price="mixinShouldPay"
                       :rule="mixinPopupPayRule"
    />
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import ClipboardJS from 'clipboard';
  import ShareMask from '@/components/ShareMask';
  import ConfirmPayPopup from '@/components/ConfirmPayPopup';
  import TeamStatus from '@/pages/GroupBuy/components/TeamDetailTeamStatus';
  import TeamCountDown from '@/pages/GroupBuy/components/TeamDetailCountDown';
  import { isWeiXinBrowser, isAppWebView } from '@/utils';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import { commonLog } from '@/services/app';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'TeamDetailStatus',
    mixins: [joinProductMixin],
    components: {
      'ym-team-status': TeamStatus,
      'ym-team-count-down': TeamCountDown,
      'ym-button': Button,
      ShareMask,
      ConfirmPayPopup,
    },
    data() {
      return {
        showShareMask: false,
      };
    },
    props: {
      status: {
        type: String,
        required: true,
      },
      buttons: {
        type: Array,
        required: true,
      },
      teamSize: {
        type: Number,
        required: true,
      },
      memberLength: {
        type: Number,
        required: true,
      },
      currentTime: {
        type: Number,
        required: true,
      },
      expiredTime: {
        type: Number,
        required: true,
      },
      productTitle: {
        type: String,
        required: true,
      },
      sharePath: {
        type: String,
      },
      originPrice: {
        type: Number,
      },
    },
    computed: {
      showTeamStatus() {
        return this.status !== 'ongoing';
      },
      primaryBtn() {
        return this.buttons.find((item, index) => index === 0);
      },
      secondaryBtn() {
        return this.buttons.find((item, index) => index === 1);
      },
    },
    methods: {
      handleShare() {
        if (isWeiXinBrowser()) {
          this.showShareMask = true;
          return;
        }
        if (isAppWebView()) {
          const wechatShare = this.$wechat.getWechatMenuShareAppParams();
          locationToAppWithRoute({
            name: 'AppBaseShare',
            params: { ...wechatShare },
          }, 1);
          return;
        }
        const clipboard = new ClipboardJS('.js-share-btn');
        clipboard.on('success', () => {
          this.showShareMask = true;
        });
      },
      async handleAction(btn) {
        const {
          targetType,
          targetId,
          action,
          hint,
        } = btn;
        btn.disabled = true;
        try {
          const product = {
            targetType,
            targetId,
            hint,
            page: this.$route.name,
            price: this.originPrice,
          };
          await this.mixinHandleClickJoinBtn(product, action);
          btn.disabled = false;
        } catch (e) {
          btn.disabled = false;
        }
      },
      handleClickBtn(btn) {
        const { action } = btn;
        switch (action) {
          case 'invite': {
            this.handleShare();
            return;
          }
          case 'joinProduct':
          case 'showProduct': {
            this.handleAction(btn);
            return;
          }
          default: {
            commonLog('TeamDetailPrimaryBtnStatusError', action);
          }
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @team-detail-action-buttons-padding: @size-base;
  .team-detail-action {
    &-buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 -(@team-detail-action-buttons-padding/2);
    }

    &-button {
      margin: 0 @team-detail-action-buttons-padding/2;
    }
  }
</style>
